export default "__VITE_ASSET__REIyk1me__"